module.exports = __webpack_public_path__ + "img/q-10-3@2x.4ff00ca2.png";